'use strict';

const AI_MODE = {
    0x00: 'AI_ABOVE',
    0x01: 'AI_BELOW',
    0x02: 'AI_WITHIN'
};

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readUInt8('data.params.analog_index');
    reader.readUInt8('data.params.mode', value => AI_MODE[value]);
    reader.readUInt32LE('data.params.lockout_time');
    reader.readUInt32LE('data.params.continue_time');
    reader.readFloatLE('data.params.high');
    reader.readFloatLE('data.params.low');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_1/common/rule/ai-condition-parser.js